<template>
  <div class="input">
    <label for="input" class="input__label">{{placeholder}}</label>
    <input type="text" autocomplete="off" @keyup="changed" v-model.trim="val" :disabled="status" />
    <span v-if="status" class="edit" @click="edit">
      <IconEdit />
    </span>
    <span v-else class="edit" @click="cancel">
      <IconEdit />
    </span>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      val: "******************",
      status: true
    };
  },
  methods: {
    changed: function(e) {
      if (!e.target.validity.valid) return;

      this.$emit("input", e.target.value);

      return;
    },
    edit: function() {
      this.status = false;
      this.val = "";
    },
    cancel: function() {
      this.status = true;
      this.val = "******************";
      this.$emit("input", null);
    }
  }
};
</script>

<style lang="scss">
.edit {
  margin-left: 374px;
  margin-top: -38px;
  cursor: pointer;
}
</style>